module.exports = __webpack_public_path__ + "img/4-4.17ed9076.svg";